import React, { type ComponentPropsWithoutRef } from 'react';
import { IS_MODERN_SSR } from '@atlassian/jira-conditional-ssr/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { Banner as BannerMain } from './main.tsx';

export function Banner(props: ComponentPropsWithoutRef<typeof BannerMain>) {
	if (!__SERVER__ || (IS_MODERN_SSR && fg('magma-3429_banners_in_modern_ssr'))) {
		return <BannerMain {...props} />;
	}
	return null;
}
